import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { BaseClass } from '../../utility/baseClass';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { HelpmasterService } from '../../main-layout/helpmaster/helpmaster.service';
@Component({
  selector: 'app-helpmastermodal',
  templateUrl: './helpmastermodal.component.html',
  styleUrls: ['./helpmastermodal.component.css']
})
export class HelpmastermodalComponent extends BaseClass implements OnInit {

  maxDate = new Date();
  helpForm: FormGroup
  tableData: any[] = [];
  productList = [];
  versionList = [];
  isDropdownOpen = false;
  isView: any;
  saveTitle = 'Add'
  isEdit: boolean = false;
  onlyView: boolean = false;
  helpId = null;
  helpDetails: any = {}
  CSRFToken = "";
  helpid: null;
  characterCount: number = 0;
  adminFlag = [
    { 'labelname': 'No', 'value': 'N' },
    { 'labelname': 'Yes', 'value': 'Y' }
  ]
  activeFlag = [
    { 'labelname': 'Active', 'value': 'Y' },
    { 'labelname': 'Inactive', 'value': 'N' }
  ]

  public validation_message = {
    product: [{ type: 'required', message: 'Product is required' }],
    topic: [
      { type: 'required', message: 'Help Topic is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    modulehelpid: [
      { type: 'required', message: 'Module Help ID is required' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'POSITIVE_INTEGER', message: 'Only positive integers are allowed' }
    ],
    adminflag: [{ type: 'required', message: 'Admin Topic is required' }],
    sequence: [
      { type: 'required', message: 'Sequence number is required' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'POSITIVE_INTEGER', message: 'Only positive integers are allowed' }
    ],
    webpage: [
      { type: 'required', message: 'Web URL is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    helptext: [
        { type: 'required', message: 'Help Topic is required' },
        { type: 'SPACESTRICTFORINITIALVALIDATION', message: 'Space is not allowed at the beginning' },
//        { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' )' },
        { type: 'maxlength', message: 'Maximum length exceeded' },
        { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
      ],
  }


  constructor(
    private GenHelpHomeService: HelpmasterService,
    private el: ElementRef, 
    public router: Router, private fb: FormBuilder,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private spinnerservice: NgxSpinnerService
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title == 'Modify') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.helpDetails = dataFromParent.datas
    }
    if (dataFromParent?.title == 'View Help Item') {
      this.isView = true;
      this.onlyView = true;
      this.saveTitle = 'View'
      this.helpDetails = dataFromParent.datas;
      this.formInitiliaze();
      this.patchValueforView(this.helpDetails)

    }

  }

  ngOnInit() {
    this.formInitiliaze();
    this.getProductList();
    this.getData()
  }
  getData() {
    if (this.isEdit) { this.patchValueForms(this.helpDetails) }
    if (this.isView) { this.patchValueforView(this.helpDetails) }

  }

  patchValueForms(data) {
    this.helpid = data[0].rid;
    this.helpForm.patchValue({ 'product': data[0].productid });
    this.helpForm.patchValue({ 'topic': data[0].topic });
    this.helpForm.patchValue({ 'webpage': data[0].webpage });
    this.helpForm.patchValue({ 'adminflag': data[0].adminflag });
    this.helpForm.patchValue({ 'sequence': data[0].sequence });
    this.helpForm.patchValue({ 'modulehelpid': data[0].modulehelpid });
    this.helpForm.patchValue({ 'helptext': data[0].helptext });
    this.helpForm.patchValue({ 'activeflag': data[0].activeflag });
  }

  patchValueforView(data) {
    this.helpForm.patchValue({ 'product': data[0].productname });
    this.helpForm.patchValue({ 'topic': data[0].topic });
    this.helpForm.patchValue({ 'webpage': data[0].webpage });
    this.helpForm.patchValue({ 'adminflag': data[0].adminflag });
    this.helpForm.patchValue({ 'sequence': data[0].sequence });
    this.helpForm.patchValue({ 'modulehelpid': data[0].modulehelpid });
    this.helpForm.patchValue({ 'helptext': data[0].helptext });
    this.helpForm.patchValue({ 'activeflag': data[0].activeflag });
  }
  getProductList() {
    this.GenHelpHomeService.getProducts().subscribe(res => {
      this.productList = res;
    })
  }

  dismiss() {
    Swal.fire({
      title: "Are you sure, you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }


  formInitiliaze() {
    this.helpForm = this.fb.group({
      product: ['', Validators.compose([Validators.required])],
      topic: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      modulehelpid: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(4),
        Validators.pattern(VALIDATION_PATTERNS.POSITIVE_INTEGER)
      ])],
      adminflag: ['', Validators.compose([Validators.required])],
      sequence: ['', Validators.compose([
          Validators.required,
        Validators.pattern(/^\d{1,5}$/),
          Validators.maxLength(4),
          Validators.pattern(VALIDATION_PATTERNS.POSITIVE_INTEGER)
        ])],
      webpage: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(200),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])],
      helptext: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(64000),
          Validators.pattern(VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION),
//          Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
          Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
        ])],
      activeflag: [''],
    })
  }

  // Add New DBScript
  add() {
    if (this.helpForm.invalid) {
      Swal.fire({
        icon: 'warning',
        title: 'Please fill up all the mandatory/required fields and then Save!',
        customClass: { icon: 'custom-skyblue-icon' },
        willClose: () => {
          this.validateAllFormFields(this.helpForm, this.el);
          setTimeout(() => {
            const firstInvalidControl = document.querySelector('.ng-invalid') as HTMLElement | null;
            if (firstInvalidControl) {
              const focusable = firstInvalidControl.querySelector<HTMLElement>(
                'input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (focusable) { focusable.focus(); }
              else {
                firstInvalidControl.tabIndex = -1;
                firstInvalidControl.focus();
              }
            }
          }, 10);
        }
      });
    }
    else if (this.helpForm.get('modulehelpid').value < 1) {
      Swal.fire('Module Help ID cannot be less than 1', '', 'error'); return;
    }
    else if (this.helpForm.get('sequence').value < 1) {
      Swal.fire('Sequence cannot be less than 1', '', 'error'); return;
    }

    else {
      const payload = {
        productid: this.helpForm.get('product').value,
        topic: this.helpForm.get('topic').value,
        webpage: this.helpForm.get('webpage').value,
        adminflag: this.helpForm.get('adminflag').value,
        sequence: this.helpForm.get('sequence').value,
        modulehelpid: this.helpForm.get('modulehelpid').value,
        helptext: this.helpForm.get('helptext').value,
        rid: this.helpid,
        csrftoken: this.CSRFToken
      }
      if (this.isEdit) {
        this.modify(payload)
      } else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
            this.spinnerservice.show();
            this.GenHelpHomeService.add(payload).subscribe((data: any) => {
              this.spinnerservice.hide();
              if (data.processid === 'exists') {
                Swal.fire("Help Text already exists!", "", "error").then(() => {
                  this.ref.close()
                });
              }
              else {
                Swal.fire("Help Item is added successfully!", "", "success").then(() => {
                  this.ref.close()
                });
              }
            }, error => {
              this.spinnerservice.hide();
              Swal.fire(error.error.message, '', 'error').then(() => {

              });
            });

          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info")
            this.ref.close()
          }
        });

      }
    }

  }

  //Modify DB Script
  modify(data: any) {
    const payload = {
      productid: this.helpForm.get('product').value,
      topic: this.helpForm.get('topic').value,
      webpage: this.helpForm.get('webpage').value,
      adminflag: this.helpForm.get('adminflag').value,
      sequence: this.helpForm.get('sequence').value,
      modulehelpid: this.helpForm.get('modulehelpid').value,
      helptext: this.helpForm.get('helptext').value,
      activeflag: this.helpForm.get('activeflag').value,
      rid: this.helpid,
      csrftoken: this.CSRFToken
    }

    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {
          this.spinnerservice.show();
          this.GenHelpHomeService.modify(payload).subscribe(() => {
            this.spinnerservice.hide();
            Swal.fire("Help Item is modified successfully!", "", "success").then(() => {
              this.ref.close()
            });
          }, error => {
            this.spinnerservice.hide();
            Swal.fire(error.error.message, '', 'error');
          });

        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info")
          this.ref.close()
        }

      });

  }

  gettoken() {
    this.CSRFToken = '';
    this.GenHelpHomeService.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    })

  }

  updateCharacterCount() {
    const value = this.helpForm.get('helptext')?.value || '';
    this.characterCount = this.stripHtmlTags(value).length;
  }

  // Function to remove HTML tags and get plain text length
  stripHtmlTags(value: string): string {
    return value.replace(/<[^>]*>/g, ''); // Remove HTML tags
  }

}
